import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField';
import { AssetsFormValues } from 'src/models/Assets.model';
import ATMFilePickerWrapper from 'src/components/UI/atoms/formFields/ATMFileUploader/ATMFileUploaderWrapper';

type Props = {
  formikProps: FormikProps<AssetsFormValues>;
  onClose: () => void;
};

const AssetsForm = ({ formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className='p-4 flex flex-col gap-6'>
      <div className='flex justify-between items-center'>
        <div className='text-xl font-medium'>  Form Heading </div>
        <button type='button' className='hover:bg-hover' onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className='flex flex-col gap-4'>
        <div>
          <ATMTextField
            name='assetName'
            value={values?.assetName}
            onChange={(e) => {
              setFieldValue('assetName', e.target.value);
            }}
            label='Assets Name'
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMFilePickerWrapper
            name="bill"
            label="File"
            placeholder="select file"
            selectedFile={values?.bill}
            onSelect={(imgUrl) => {
              setFieldValue("bill", imgUrl);
            }}
          />
        </div>
      
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type='submit'>
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default AssetsForm;